<template>
  <div>
    <div class="ts-grid ts-grid-cols-3 ts-gap-6 ts-mt-3">
      <div class="ts-w-full ts-text-right">
        <label class="required ts-font-robot">{{
          $t('projectProfile.name')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <input
          v-model="model.milestone_name"
          type="text"
          class="form-control"
          placeholder="Input milestone name. ex: Develop"
        />
        <div class="validate" v-if="errors.has('milestone_name')">
          {{ errors.first('milestone_name') }}
        </div>
      </div>
      <div class="ts-w-full ts-text-right">
        <label class="required ts-font-robot">{{
          $t('projectProfile.status')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-select
          v-model="model.status_id"
          :options="projectStatus"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          class="ts-w-full"
          placeholder="Select who is main response"
        ></a-select>
        <div class="validate" v-if="errors.has('status_id')">
          {{ errors.first('status_id') }}
        </div>
      </div>
      <div class="ts-w-full ts-text-right">
        <label class="required ts-font-robot">{{
          $t('projectProfile.owner')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-select
          v-model="model.milestone_owner"
          :options="owners"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          class="ts-w-full"
          placeholder="Select who is main response"
        ></a-select>
        <div class="validate" v-if="errors.has('milestone_owner')">
          {{ errors.first('milestone_owner') }}
        </div>
      </div>
      <div class="ts-w-full ts-text-right">
        <label class="ts-font-robot">{{
          $t('projectProfile.estimated')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-range-picker
          v-model="model.estimated_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          class="ts-w-full"
        />
        <div class="validate" v-if="errors.has('estimated_date')">
          {{ errors.first('estimated_date') }}
        </div>
      </div>
      <div class="ts-w-full ts-text-right">
        <label class="ts-font-robot ts-capitalize">{{
          $t('projectProfile.actual')
        }}</label>
      </div>
      <div class="ts-col-span-2">
        <a-range-picker
          v-model="model.actual_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          class="ts-w-full"
        />
        <div class="validate" v-if="errors.has('actual_date')">
          {{ errors.first('actual_date') }}
        </div>
      </div>
    </div>
    <div class="row ts-mt-4">
      <div
        class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
      >
        <ts-button @click.prevent="$emit('cancel')"
          >{{ $t('cancel') }}
        </ts-button>
        <ts-button :disabled="loading" @click.prevent="save" color="primary">{{
          $t('save')
        }}</ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  props: ['projectId'],
  data() {
    return {
      errors: new Errors(),
      owners: [],
      projectStatus: [],
      loading: false,
      model: {
        project_id: '',
        milestone_name: '',
        milestone_owner: '',
        milestone_member: [],
        estimated_date: undefined,
        actual_date: undefined,
        status_id: 1
      }
    }
  },
  created() {
    this.model.project_id = this.projectId
    this.fetchViewModel()
  },
  methods: {
    ...mapActions('projectMgt/projectMilestone', ['formViewModel', 'store']),
    fetchViewModel: debounce(function() {
      this.loading = true
      this.formViewModel({
        fnName: 'owner,status',
        project_id: this.projectId
      })
        .then(response => {
          this.owners = response.data.owner.map(el => ({
            value: el.user_id,
            label: el.employee_name_kh + '|' + el.employee_name_en
          }))
          this.projectStatus = response.data.status.map(el => ({
            value: el.status_id,
            label: el.project_status
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }, 500),
    save() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$emit('milestone', response.milestone)
          this.$emit('cancel', false)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.milestone_name = ''
      this.model.milestone_owner = ''
      this.model.milestone_member = []
      this.model.estimated_date = undefined
      this.model.actual_date = undefined
      this.model.status_id = 1
    },
    onClose() {
      this.$emit('close', false)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
